import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';

/**
 * Event settings card — app title, footer, season year, seats & parking counts.
 * Purely presentational — parent owns the settings state.
 */
export const EventSettingsCard = ({ settings, allGames, onChange }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>🎨 Appearance</CardTitle>
        <CardDescription>Customize the look and feel of your application</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="text-sm font-medium">Application Title (Desktop)</label>
          <Input
            value={settings.app_title || ''}
            onChange={(e) => onChange('app_title', e.target.value)}
            className="mt-1"
            placeholder="Dallas Mavericks - Home Game Ticket Scorecard"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Footer Text</label>
          <Input
            value={settings.footer_text || ''}
            onChange={(e) => onChange('footer_text', e.target.value)}
            className="mt-1"
            placeholder="Enter footer text (optional)"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Season Year</label>
          <Input
            value={settings.season_year || ''}
            onChange={(e) => onChange('season_year', e.target.value)}
            className="mt-1"
            placeholder="2025-26"
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div>
            <label className="text-sm font-medium">Total Home Games</label>
            <div className="mt-1 px-3 py-2 bg-muted rounded-md text-sm font-medium">
              {allGames.filter(g => g.type !== 'playoff' && g.season_type !== 'playoff').length}
              <span className="text-muted-foreground text-xs ml-1">(from loaded games)</span>
            </div>
          </div>
          <div>
            <label className="text-sm font-medium">Playoff Games</label>
            <div className="mt-1 px-3 py-2 bg-muted rounded-md text-sm font-medium">
              {allGames.filter(g => g.type === 'playoff' || g.season_type === 'playoff').length}
              <span className="text-muted-foreground text-xs ml-1">(from loaded games)</span>
            </div>
          </div>
          <div>
            <label className="text-sm font-medium">Total Seats per Game</label>
            <Input
              type="number"
              value={settings.total_seats || 6}
              onChange={(e) => onChange('total_seats', parseInt(e.target.value) || 0)}
              className="mt-1"
              min="1"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Parking Passes per Game</label>
            <Input
              type="number"
              value={settings.total_parking ?? 2}
              onChange={(e) => onChange('total_parking', parseInt(e.target.value) || 0)}
              className="mt-1"
              min="0"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EventSettingsCard;
